export default __webpack_public_path__ + "static/media/butter-cup-ad.d06fa0e9.png";